

exports.__esModule = true;
exports.$event = undefined;

var _promise = require("./promise");

var handlers = {};

var customEventEmitter = void 0;

var $event = exports.$event = {
    use: function use(eventEmitter) {
        customEventEmitter = eventEmitter;

        for (var _iterator = Object.keys(handlers), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
            var _ref;

            if (_isArray) {
                if (_i >= _iterator.length) break;
                _ref = _iterator[_i++];
            } else {
                _i = _iterator.next();
                if (_i.done) break;
                _ref = _i.value;
            }

            var eventName = _ref;

            if (handlers[eventName]) {
                for (var _iterator2 = handlers[eventName], _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
                    var _ref2;

                    if (_isArray2) {
                        if (_i2 >= _iterator2.length) break;
                        _ref2 = _iterator2[_i2++];
                    } else {
                        _i2 = _iterator2.next();
                        if (_i2.done) break;
                        _ref2 = _i2.value;
                    }

                    var handler = _ref2;

                    customEventEmitter.on(eventName, handler);
                }
            }
        }
    },
    on: function on(eventName, method) {

        if (customEventEmitter) {
            return customEventEmitter.on(eventName, method);
        }

        handlers[eventName] = handlers[eventName] || [];
        handlers[eventName].push(method);

        var cancelled = false;

        function cancel() {
            if (!cancelled) {
                handlers[eventName].splice(handlers[eventName].indexOf(method), 1);
                cancelled = true;
            }
        }

        cancel.cancel = cancel;
        return cancel;
    },
    once: function once(eventName, method) {

        if (customEventEmitter) {
            return customEventEmitter.once(eventName, method);
        }

        var listener = $event.on(eventName, function () {
            listener.cancel();
            return method.apply(this, arguments);
        });

        return listener;
    },
    emit: function emit(eventName) {
        if (customEventEmitter) {
            var _customEventEmitter;

            return (_customEventEmitter = customEventEmitter).emit.apply(_customEventEmitter, arguments);
        }

        var event = {
            preventDefault: function preventDefault() {
                event.defaultPrevented = true;
            }
        };

        if (handlers[eventName]) {
            for (var _iterator3 = Array.prototype.slice.apply(handlers[eventName]), _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _iterator3[Symbol.iterator]();;) {
                var _ref3;

                if (_isArray3) {
                    if (_i3 >= _iterator3.length) break;
                    _ref3 = _iterator3[_i3++];
                } else {
                    _i3 = _iterator3.next();
                    if (_i3.done) break;
                    _ref3 = _i3.value;
                }

                var handler = _ref3;

                handler.apply(this, [event].concat(Array.prototype.slice.call(arguments)));
            }
        }

        return event;
    },
    broadcast: function broadcast(eventName) {

        if (customEventEmitter) {
            var _customEventEmitter2;

            return (_customEventEmitter2 = customEventEmitter).broadcast.apply(_customEventEmitter2, arguments);
        }

        return $event.emit.apply($event, arguments);
    },


    refCount: function refCount($scope, start, stop) {
        return _promise.$promise.resolver(function (resolve) {

            var count = 0;

            var cancelStartListener = $scope.$on(start, function (event, data) {
                count += 1;
            });

            var cancelStopListener = $scope.$on(stop, function (event, data) {
                setTimeout(function () {
                    count -= 1;
                    res(); // eslint-disable-line no-use-before-define
                }, 50);
            });

            function res() {
                if (!count) {

                    if (cancelStartListener && cancelStopListener) {
                        cancelStartListener();
                        cancelStopListener();
                    }

                    return resolve();
                }
            }

            setTimeout(res, 50);
        });
    },

    compose: function compose(start, end, startAll, endAll) {
        var debounce = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;


        var count = 0;
        var active = false;

        $event.on(start, function () {
            if (!count) {
                setTimeout(function () {
                    if (count && !active) {
                        active = true;
                        $event.emit(startAll);
                    }
                }, debounce);
            }

            count += 1;
        });

        $event.on(end, function () {

            setTimeout(function () {
                count -= 1;

                if (!count && active) {
                    active = false;
                    $event.emit(endAll);
                }
            }, 0);
        });

        return {
            getCount: function getCount() {
                return count;
            },
            isActive: function isActive() {
                return Boolean(count);
            },
            reset: function reset() {
                count = 0;
            }
        };
    }
};

angular.value("$event", $event);
_promise.$promise;


//////////////////
// WEBPACK FOOTER
// ./components/squid/dist/core/event.js
// module id = ./components/squid/dist/core/event.js
// module chunks = 1